import React, {useState, useEffect} from 'react';
// import {UncontrolledTooltip, Tooltip} from 'reactstrap';
import './style.scss';
// import ReactTooltip from 'react-tooltip';

import {Input, InputGroup, InputGroupAddon, InputGroupText} from 'reactstrap';

const InputWithError = (props) => {
    const {
        prependIcon, onChange, autoCompleteOn, errorObj, name, marginBottomClass,
        placeholder, value, type, disabled, tooltipText, tooltipId, onPressEnter,
        disableAutoComplete
    } = props;
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggle = () => setTooltipOpen(!tooltipOpen);
    const hasError = errorObj && errorObj.hasOwnProperty(name);

    const handleEnterPress = (e) => {
        if(e.keyCode === 13 && onPressEnter) {
            onPressEnter();
        }
    };

    return (
        <div
            className={'d-flex flex-column flex-1 ' + (hasError ? 'mb-2' : (marginBottomClass ? marginBottomClass : 'mb-4'))}>
            <InputGroup className={'m-0 ' + (hasError ? 'input-group-with-error' : '')}>
                {prependIcon &&
                <>
                    <InputGroupAddon
                        addonType="prepend"
                        data-tip={tooltipText}
                    >
                        <InputGroupText>{prependIcon}</InputGroupText>
                    </InputGroupAddon>
                    {/*<ReactTooltip*/}
                    {/*    place="bottom"*/}
                    {/*    effect="solid"*/}
                    {/*    delayShow={200}*/}
                    {/*    className="tooltip-thin"*/}
                    {/*/>*/}
                    {/*{tooltipText &&*/}
                    {/*<UncontrolledTooltip*/}
                    {/*    placement="bottom"*/}
                    {/*    // target={tooltipId}*/}
                    {/*    target="bingo1"*/}
                    {/*    delay={{show: 300, hide: 0}}*/}
                    {/*>Test of one of the tester</UncontrolledTooltip>*/}
                    {/*}*/}
                </>
                }
                <Input
                    autoComplete={disableAutoComplete ? 'new-password' : ''}
                    placeholder={placeholder}
                    value={value}
                    type={type}
                    disabled={disabled}
                    onKeyDown={(e) => handleEnterPress(e)}
                    onChange={(e) => onChange(e.target.value)}
                    style={{borderLeft: (!prependIcon && hasError) ? '1px solid red' : ''}}
                />
            </InputGroup>
            {hasError &&
            <div className="error-text mt-1">
                {errorObj[name][0].message}
            </div>
            }
        </div>
    );
};

export default InputWithError;
